<template>
  <!-- 商品列表 -->
  <div class="h-full overflow-y-scroll scrollbar-hide">
    <SearchGoods @getSearchContent="getSearchContent" />
    <!-- 商品列表 -->
    <LoadingVue v-if="fetching" class="h-14 mx-auto my-20" />
    <template v-else>
      <div>
        <div class="grid grid-cols-3 gap-2 px-1 mt-1">
          <ListItem :item="item" v-for="item in list" :key="item.no" />
        </div>
      </div>
      <!-- 當沒有商品 -->
      <div class="py-2" v-if="!hasRecords">
        <p class="text-center tracking-wider text-sm text-chicago leading-10">
          相關商品暫時缺貨
        </p>
      </div>
    </template>

    <div class="h-[20vh]"></div>
  </div>
</template>

<script>
import ListItem from "@/components/product/ListItem";
import SearchGoods from "@/components/product/SearchGoods";
import LoadingVue from "@/components/icons/Loading.vue";
import { mapGetters } from "vuex";
import { toLower } from "lodash";
export default {
  components: {
    ListItem,
    SearchGoods,
    LoadingVue,
  },
  
  methods: {
    getSearchContent(value) {
      this.mapQuery({
        keywords: value,
      });
    }
  },

  computed: {
    ...mapGetters({
      goods: "app/goods",
      catalogs: "app/catalogs",
      categories: "app/categories",
      fetching: "app/fetching",
    }),
    title() {
      return this.$route.query.title ?? "全部";
    },
    list() {
      const category = this.$route.query.category;
      const keywords = this.$route.query.keywords;

      let list = [...this.categories];

      // toLower(item.name).includes(toLower(keywords)) ||
      if (category) {
        list = list.filter((item) => {
          return (
            item.parents.map((i) => i.no + "").includes(category) ||
            item.parents.filter((i) =>
              i.parents.map((ii) => ii.no + "").includes(category)
            ).length
          );
        });
      }

      if (keywords) {
        list = list.filter((item) => {
          return toLower(item.name).includes(toLower(keywords));
        });
      }

      // sort by parents.order
      list = list.sort((a, b) => {
        const aParents = a.parents.map((i) => i.order);
        const bParents = b.parents.map((i) => i.order);
        const aOrder = aParents[aParents.length - 1];
        const bOrder = bParents[bParents.length - 1];
        return aOrder - bOrder;
      });

      // sort by order
      list = list.sort((a, b) => {
        return a.order - b.order;
      });

      return list;
    },
    hasRecords() {
      return this.list && this.list.length != 0;
    },
  },
  
};
</script>

<style lang="scss" scoped></style>
